import React from "react";
import { Typography } from "../../../atoms";
import LinearProgress from "../../../atoms/LinearProgress";
import { QualityCategory, QualityStatus } from "../types";
import styles from "./index.style.module.css";

export interface ContentQualityCardProps {
  category: QualityCategory;
  status: QualityStatus;
  progress: number;
  className?: string;
}

const STATUS_COLORS: Record<QualityStatus, string> = {
  Healthy: "#008253",
  Stable: "#ff7900",
  Critical: "#a20f2c",
};

const ContentQualityCard: React.FC<ContentQualityCardProps> = ({
  category,
  status,
  progress,
  className = "",
}) => {
  const progressColor = STATUS_COLORS[status];

  return (
    <div className={`${styles.contentQualityCard} ${className}`}>
      <Typography
        variant="text-xs"
        weight="bold"
        className={styles.categoryLabel}
      >
        {category}
      </Typography>
      <div className={styles.statusContainer}>
        <Typography
          variant="text-xs"
          weight="regular"
          className={styles.statusLabel}
        >
          {status}
        </Typography>
        <LinearProgress
          value={progress}
          max={100}
          gradientStartColor={progressColor}
          gradientEndColor={progressColor}
          height={4}
          borderRadius={16}
          squareProgressEnd
        />
      </div>
    </div>
  );
};

export default ContentQualityCard;
